import { render, staticRenderFns } from "./CtaMoisesSleepe.vue?vue&type=template&id=0b335484"
import script from "./CtaMoisesSleepe.vue?vue&type=script&lang=js"
export * from "./CtaMoisesSleepe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports